gsap.registerPlugin(ScrollTrigger);

gsap.from(['.preorder', '.design-by'], {
  y: 20,
  opacity: 0,
  stagger: 0.15,
  duration: 0.6,
  delay: 0.3
});

// ── MENU LATERAL ─────────────────────────────────────────────
const sideNav = document.getElementById('sectionNav');

if (sideNav) {
  gsap.set(sideNav, { autoAlpha: 0, pointerEvents: 'none' });

  ScrollTrigger.create({
    trigger: '#made',
    start: 'top 80%',
    endTrigger: '#modular',   // aparece em MADE, desaparece ao sair de MODULAR
    end: 'bottom 40%',
    onEnter: () => {
      sideNav.classList.add('is-visible');
      gsap.to(sideNav, { autoAlpha: 1, pointerEvents: 'auto', duration: 0.25 });
    },
    onLeaveBack: () => {
      gsap.to(sideNav, { autoAlpha: 0, pointerEvents: 'none', duration: 0.2,
        onComplete: () => sideNav.classList.remove('is-visible') });
    },
    onLeave: () => {
      gsap.to(sideNav, { autoAlpha: 0, pointerEvents: 'none', duration: 0.2,
        onComplete: () => sideNav.classList.remove('is-visible') });
    },
    onEnterBack: () => {
      sideNav.classList.add('is-visible');
      gsap.to(sideNav, { autoAlpha: 1, pointerEvents: 'auto', duration: 0.25 });
    }
  });
}

// ── HIGHLIGHT DO ITEM ATIVO ───────────────────────────────────
document.querySelectorAll('[data-nav-section]').forEach(sec => {
  ScrollTrigger.create({
    trigger: sec,
    start: 'top 35%',
    end: 'bottom 35%',
    onToggle: self => {
      if (self.isActive) {
        document.querySelectorAll('.section-nav__item').forEach(a =>
          a.classList.toggle('active', a.dataset.section === sec.dataset.navSection)
        );
      }
    }
  });
});

// ── WORKSTATION VIDEO PARALLAX ────────────────────────────────
gsap.to('.workstation-video', {
  scale: 1,
  ease: 'none',
  scrollTrigger: {
    trigger: '#workstation',
    start: 'top bottom',
    end: 'bottom top',
    scrub: 1.5
  }
});

// ── ANIMAÇÃO DE ENTRADA NAS FEATURES ─────────────────────────
gsap.utils.toArray('.feature-item,.made-grid').forEach(item => {
  const img = item.querySelector('img');
  if (img) {
    gsap.from(img, {
      y: 40,
      opacity: 0,
      duration: 0.8,
      scrollTrigger: { trigger: item, start: 'top 85%' }
    });
  }
});

// ── CONTADOR DE MATERIAL ──────────────────────────────────────
const kgEl = document.getElementById('kgCount');
const lEl  = document.getElementById('lCount');

if (kgEl && lEl) {
  ScrollTrigger.create({
    trigger: '#material',
    start: 'top 75%',
    onEnter: self => {
      const kg = { val: 0 };
      gsap.to(kg, {
        val: 56,
        duration: 2,
        ease: 'power2.out',
        onUpdate: () => { kgEl.textContent = Math.round(kg.val); }
      });
      const l = { val: 0 };
      gsap.to(l, {
        val: 316,
        duration: 2.2,
        ease: 'power2.out',
        delay: 0.2,
        onUpdate: () => { lEl.textContent = Math.round(l.val); }
      });
      self.kill();
    }
  });
}

// ── VITRINE 360° — SELETOR DE CORES ──────────────────────────
const colorOptions = document.querySelectorAll('.color-option');
const bancadaVideo = document.getElementById('bancadaVideo');

if (colorOptions.length && bancadaVideo) {
  // Usa data-video-* se disponível (Shopify CDN), senão fallback local
  const videos = {
    black: bancadaVideo.dataset.videoBlack || 'img/bancada-preta-360.mp4',
    white: bancadaVideo.dataset.videoWhite || 'img/bancada-branca-360.mp4',
    green: bancadaVideo.dataset.videoGreen || 'img/bancada-green-360.mp4'
  };

  colorOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      if (e.target.closest('.buy-now-btn')) return;

      colorOptions.forEach(b => b.classList.remove('active'));
      option.classList.add('active');

      const color = option.dataset.color;
      bancadaVideo.style.opacity = '0';

      setTimeout(() => {
        bancadaVideo.src = videos[color];
        bancadaVideo.load();
        bancadaVideo.play();
        bancadaVideo.style.opacity = '1';
      }, 300);
    });
  });
}

// ── CARROSSEL DE REVIEWS — DRAG + SETAS ──────────────────────
const reviewsTrack = document.getElementById('reviewsTrack');
const reviewsPrev  = document.querySelector('.reviews-arrow.prev');
const reviewsNext  = document.querySelector('.reviews-arrow.next');

if (reviewsTrack) {
  let isDown = false, startX, scrollLeft;

  reviewsTrack.addEventListener('pointerdown', (e) => {
    isDown = true;
    startX = e.pageX - reviewsTrack.offsetLeft;
    scrollLeft = reviewsTrack.scrollLeft;
    reviewsTrack.setPointerCapture(e.pointerId);
  });

  reviewsTrack.addEventListener('pointermove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x    = e.pageX - reviewsTrack.offsetLeft;
    const walk = (x - startX) * 1.8;
    reviewsTrack.scrollLeft = scrollLeft - walk;
  });

  reviewsTrack.addEventListener('pointerup',    () => { isDown = false; });
  reviewsTrack.addEventListener('pointerleave', () => { isDown = false; });

  const scrollAmount = 340;
  reviewsPrev?.addEventListener('click', () => {
    reviewsTrack.scrollBy({ left: -scrollAmount * 2, behavior: 'smooth' });
  });
  reviewsNext?.addEventListener('click', () => {
    reviewsTrack.scrollBy({ left: scrollAmount * 2, behavior: 'smooth' });
  });
}

// ── WHOLESALERS FORM — Klaviyo Client API ────────────────────
const KLAVIYO_SITE_ID = 'V6acte';
const KLAVIYO_LIST_ID = 'YciH2d';

const wsForm      = document.getElementById('wsForm');
const wsSubmitBtn = document.getElementById('wsSubmitBtn');
const wsSuccess   = document.getElementById('wsSuccess');
const wsError     = document.getElementById('wsError');

if (wsForm) {
  wsForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email   = document.getElementById('ws-email').value.trim();
    const name    = document.getElementById('ws-name').value.trim();
    const phone   = document.getElementById('ws-phone').value.trim();
    const country = document.getElementById('ws-country').value.trim();
    const message = document.getElementById('ws-message').value.trim();

    if (!email || !name || !phone || !country || !message) {
      wsForm.reportValidity();
      return;
    }

    const parts     = name.split(' ');
    const firstName = parts[0];
    const lastName  = parts.slice(1).join(' ');

    wsSubmitBtn.disabled    = true;
    wsSubmitBtn.textContent = 'Sending...';
    wsSuccess.hidden        = true;
    wsError.hidden          = true;

    try {
      const profileRes = await fetch(
        `https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_SITE_ID}`,
        {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'profile',
              attributes: {
                email,
                phone_number: phone,
                first_name:   firstName,
                last_name:    lastName,
                location: { country },
                properties: {
                  wholesaler_message: message,
                  wholesaler_source:  'Workstation 1.0 — Wholesalers Form',
                },
              },
            },
          }),
        }
      );

      if (!profileRes.ok && profileRes.status !== 409) {
        throw new Error(`Profile: ${profileRes.status}`);
      }

      const subRes = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_SITE_ID}`,
        {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Wholesalers Form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      phone_number: phone,
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id:   KLAVIYO_LIST_ID,
                  },
                },
              },
            },
          }),
        }
      );

      if (!subRes.ok) throw new Error(`Subscription: ${subRes.status}`);

      wsSuccess.hidden = false;
      wsForm.reset();

    } catch (err) {
      console.error('[Wholesalers Klaviyo]', err);
      wsError.hidden = false;

    } finally {
      wsSubmitBtn.disabled  = false;
      wsSubmitBtn.innerHTML = 'Submit <span class="ws-arrow">›</span>';
    }
  });
}

// ── TICKER INFINITO ───────────────────────────────────────────
const tickerTrack = document.querySelector('.ticker-track');

if (tickerTrack) {
  gsap.set(tickerTrack, { xPercent: -50 });
  gsap.to(tickerTrack, {
    xPercent: 0,
    duration: 25,
    ease: 'none',
    repeat: -1
  });
}